export default __webpack_public_path__ + "static/media/Girdle of the Savage Fang.794789b0.jpg";